import { compose } from 'recompose';
import apiInterceptor from '../../../api/interceptor';
import { vatReportApi } from '../../common/base.api';
import VatReport from './VatReport';

const composedVatReport = compose(apiInterceptor({ ...vatReportApi }))(VatReport);

export default composedVatReport;
